import React, { useState, useEffect } from 'react';
import { Modal, Form, Col, Row, Button, Spin, Divider  } from 'antd';
import { observer } from 'mobx-react';
import store from './store';
import { history,formatDate } from 'libs';
import styles from './layout.module.less';
import { UploadFile } from 'components';
// import gStore from 'store';

export default observer(function IForm() {
  const [form] = Form.useForm();
  // const [data,setData] = useState({});
  // const [title,setTitle] = useState('');
  // const [orderTestingList,setOrderTestingList] = useState([]);
  // const [orderTransferList,setOrderTransferList] = useState([]);
  // const [otherList,setOtherList] = useState([]);

  // useEffect(()=>{
  //   let cloneData = {}
  //   // setOrderTestingList(store.record.orderTestingList||[]);
  //   // setOrderTransferList(store.record.orderTransferList||[]);
  //   // setOtherList(store.record.otherList||[]);
  //   if (store.f_type === 'Sale') {
  //     // cloneData = {...store.record.orderSale};
  //     setTitle('销售');
  //   }else if(store.f_type === 'Rent'){
  //     // cloneData = {...store.record.orderRent};
  //     setTitle('租赁');
  //   }else{
  //     // cloneData = {...store.record.orderStore};
  //     setTitle('仓储');
  //   }
  //   // setData(cloneData)
  // },[store.record])

  // const handleLinkOrder = (orderSn)=>{
  //   // gStore.selectedKeys = ['/equipment/saleOrder'];
  //   history.push({ pathname: '/user/order', state: { orderSn: orderSn } })
  //   store.formVisible = false;
  // }

  const handleWatchCert = (path)=>{
    window.open(process.env.REACT_APP_file_domain + path);
  }

  return (
    <Modal
      open
      maskClosable={false}
      closable={true}
      title="查看设备详情"
      destroyOnClose={true}
      onCancel={()=>store.formVisible = false}
      className={styles.modalContainer}
      footer={[
        <Button key="back" onClick={()=>store.formVisible = false}>
          关闭
        </Button>
      ]}
      width={1500}>
        {
          store.detailFetching?
          <Spin/>:
          <Form form={form} labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} size={'middle'} labelAlign={'right'}>
            {store.record.otherList.map((item,index)=>{
              if (item.catalog === 'Sale'||item.catalog === 'Rent'||item.catalog === 'Store') {
                return (
                  <>
                  <h3><strong>{item.catalogName}</strong></h3>
                  <Row>  
                      <Col span={8}>
                        <Form.Item label="下单日期">
                          <div>{formatDate(item.orderCreatedAt)}</div>
                        </Form.Item>
                        <Form.Item label="产品品牌" >
                            <div>{item.brandName}</div> 
                        </Form.Item>
                        <Form.Item label="含税单价"> 
                            <div>{item.price}</div>
                        </Form.Item>
                        <Form.Item label="设备名称">
                            <div>{item.deviceProductName}</div>
                        </Form.Item>
                        <Form.Item label="医院名称">
                            <div>{item.hospitalName}</div>
                        </Form.Item>
                        <Form.Item label="联系人">
                            <div>{item.name}</div>
                        </Form.Item>
                        <Form.Item label="开票金额">
                            <div>{item.invoicePrice}</div>
                        </Form.Item>
                        <Form.Item label="项目号">
                            <div>{item.projectNo}</div>
                        </Form.Item>
                        <Form.Item label="发货日期">
                        <div>{formatDate(item.sendDate)}</div>
                    </Form.Item>
                        {
                        item.catalog !== 'Sale'&&
                        <Form.Item label="校准开始日期">
                        <div>{formatDate(item.certStartDate)}</div>
                        </Form.Item>
                      }
                          <Form.Item label="校准结束日期">
                          <div>{formatDate(item.certEndDate)}</div>
                      </Form.Item>
                    {
                        item.catalog === 'Store'&&
                        <>
                        <Form.Item label="存放地点">
                            <div>{item.storeName}</div>
                        </Form.Item>
                        </>
                      }
                      </Col>
                      <Col span={8}>
                        <Form.Item label="订单号">
                        <div>{item.orderSn}</div>
                        </Form.Item>
                        <Form.Item label="货号">
                            <div>{item.factoryCode}</div>
                        </Form.Item>
                        <Form.Item label="未税单价">
                            <div>{item.priceWithoutTax}</div>
                        </Form.Item>
                        <Form.Item label="设备编码">
                            <div>{item.deviceMaterialCode}</div>
                        </Form.Item>
                        <Form.Item label="中心号">
                            <div>{item.centerNo}</div>
                        </Form.Item>
                        <Form.Item label="手机号">
                            <div>{item.phone}</div>
                        </Form.Item>
                        <Form.Item label="开票日期">
                            <div>{formatDate(item.invoiceDate)}</div>
                        </Form.Item>
                        <Form.Item label="负责人">
                            <div>{item.manageUserName}</div>
                        </Form.Item>
                      {
                        item.catalog === 'Store'&&
                        <>
                        <Form.Item label="随附配件">
                            <div>{item.itemContent}</div>
                        </Form.Item>
                        <Form.Item label="随附文件">
                            <div>{item.fileContent}</div>
                        </Form.Item>
                        <Form.Item label="计费结束日期">
                            <div>{formatDate(item.feeEndDate)}</div>
                        </Form.Item>
                        </>
                      }
                      {
                        item.catalog === 'Rent'&&
                        <>
                        <Form.Item label="租期">
                            <div>{item.rentMonth}</div>
                        </Form.Item>
                        <Form.Item label="当前投放地点">
                            <div>{item.hospitalAddress}</div>
                        </Form.Item>
                        </>
                      }
                      </Col>
                      <Col span={8}>
                        <Form.Item label="产品名称" >
                          <div>{item.goodsName}</div>
                        </Form.Item>
                        <Form.Item label="产品编码" >
                          <div>{item.materialCode}</div>
                        </Form.Item>
                        <Form.Item label="税率" >
                        <div>{(item.taxRate||item.taxRate===0)&&`${item.taxRate}%`}</div>
                        </Form.Item>
                        <Form.Item label="序列号" >
                          <div>{item.deviceSerialNo}</div>
                        </Form.Item>
                        <Form.Item label="PO号" >
                          <div>{item.purchaseNo}</div>
                        </Form.Item>
                  
                        <Form.Item label="联系地址">
                          <div>{item.address}</div>
                        </Form.Item>
                        <Form.Item label="物流单号">
                        <div>{item.expressNo}</div>
                        </Form.Item>
                      {
                        item.catalog === 'Store'&&
                        <>
                        <Form.Item label="货物入库状态">
                        <div>{item.status}</div>
                        </Form.Item>
                        <Form.Item label="入库日期">
                            <div>{formatDate(item.inDate)}</div>
                        </Form.Item>
                        <Form.Item label="出库日期">
                            <div>{formatDate(item.outDate)}</div>
                        </Form.Item>
                        <Form.Item label="计费开始日期">
                            <div>{formatDate(item.feeStartDate)}</div>
                        </Form.Item>
                        </>
                      }
                        {
                        item.catalog === 'Rent'&&
                        <>
                        <Form.Item label="起租日期">
                            <div>{formatDate(item.startDate)}</div>
                        </Form.Item>
                        <Form.Item label="到期日期">
                            <div>{formatDate(item.endDate)}</div>
                        </Form.Item>
                        <Form.Item label="退租日期">
                            <div>{formatDate(item.exitDate)}</div>
                        </Form.Item>
                        </>
                      }
                        {
                        item.catalog === 'Sale'&&
                        <Form.Item label="校准开始日期">
                        <div>{formatDate(item.certStartDate)}</div>
                        </Form.Item>
                      }
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Form.Item label="用户备注" >
                          <div>{item.userRemark}</div>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="泉心备注" >
                          <div>{item.selfRemark}</div>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Form.Item label="证书上传" >
                          <UploadFile
                            fromEntity={"Order"+item.catalog}
                            catalog="Annex"
                            color="#47B2AC"
                            itemInfo = {item}
                            exportType = 'DeviceExportCert'
                            fromEntityId={item.id || ''}
                            isAbleUpload={false}
                          />
                          {/* {item.filePath&&<Button type='link' onClick={()=>{handleWatchCert(item.filePath)}}>查看证书</Button>} */}
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )
              }
              return <>
                {index!==0 && <Divider />}
                <h3><strong>{item.catalog==="Testing"?"计量":"转运"}</strong></h3>
                {
                  //计量详情
                  item.catalog==="Testing"&&
                  <>
                  <Row>
                  <Col span={8}>
                    <Form.Item label="下单日期">
                      <div>{formatDate(item.orderCreatedAt)}</div>
                    </Form.Item>
                    <Form.Item label="产品品牌" >
                        <div>{item.brandName}</div> 
                    </Form.Item>
                    <Form.Item label="含税单价"> 
                        <div>{item.price}</div>
                    </Form.Item>
                    <Form.Item label="校准开始日期">
                        <div>{formatDate(item.certStartDate)}</div>
                    </Form.Item>
                    <Form.Item label="开票金额">
                        <div>{item.invoicePrice}</div>
                    </Form.Item>
                    <Form.Item label="联系人">
                        <div>{item.name}</div>
                    </Form.Item>
                    {/* <Form.Item label="医院名称">
                            <div>{item.hospitalName}</div>
                        </Form.Item> */}
                        <Form.Item label="序列号" >
                          <div>{item.deviceSerialNo}</div>
                        </Form.Item>
                  </Col>
                  <Col span={8}>
                      <Form.Item label="订单号">
                      <div>{item.orderSn}</div>
                        </Form.Item>
                    <Form.Item label="货号">
                        <div>{item.factoryCode}</div>
                    </Form.Item>
                    <Form.Item label="未税单价">
                        <div>{item.priceWithoutTax}</div>
                    </Form.Item>
                    <Form.Item label="校准结束日期">
                        <div>{formatDate(item.certEndDate)}</div>
                    </Form.Item>
                    <Form.Item label="开票日期">
                        <div>{formatDate(item.invoiceDate)}</div>
                    </Form.Item>
                    <Form.Item label="手机号">
                        <div>{item.phone}</div>
                    </Form.Item>
                    <Form.Item label="发货日期">
                        <div>{formatDate(item.sendDate)}</div>
                    </Form.Item>
                    {/* <Form.Item label="中心号">
                            <div>{item.centerNo}</div>
                        </Form.Item> */}
                  </Col>
                  <Col span={8}>
                    <Form.Item label="产品名称" >
                      <div>{item.goodsName}</div>
                    </Form.Item>
                    <Form.Item label="产品编码" >
                      <div>{item.materialCode}</div>
                    </Form.Item>
                    <Form.Item label="税率" >
                      <div>{(item.taxRate||item.taxRate===0)&&`${item.taxRate}%`}</div>
                    </Form.Item>
                    <Form.Item label="上门日期" >
                      <div>{formatDate(item.receiveDate)}</div>
                    </Form.Item>
                    <Form.Item label="物流单号">
                        <div>{item.expressNo}</div>
                    </Form.Item>
                    <Form.Item label="地址">
                        <div>{item.address}</div>
                    </Form.Item>
                  </Col>
                </Row>
                      <Row>
                      <Col span={8}>
                        <Form.Item label="用户备注" >
                          <div>{item.userRemark}</div>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="泉心备注" >
                          <div>{item.selfRemark}</div>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Form.Item label="证书上传" >
                            <UploadFile
                            fromEntity={"Order"+item.catalog}
                            catalog="Annex"
                            itemInfo = {item}
                            exportType = 'DeviceExportCert'
                            color="#47B2AC"
                            fromEntityId={item.id || ''}
                            isAbleUpload={false}
                          />
                          {/* {item.filePath&&<Button type='link' onClick={()=>{handleWatchCert(item.filePath)}}>查看证书</Button>} */}
                        </Form.Item>
                      </Col>
                    </Row>
                    </>
                }
                {
                  //转运详情
                  item.catalog==="Transfer"&&
                  <>
                  <Row>
                  <Col span={8}>
                    <Form.Item label="下单日期">
                      <div>{formatDate(item.orderCreatedAt)}</div>
                    </Form.Item>
                    <Form.Item label="产品品牌" >
                        <div>{item.brandName}</div> 
                    </Form.Item>
                    <Form.Item label="含税单价"> 
                        <div>{item.price}</div>
                    </Form.Item>
                    <Form.Item label="开票金额">
                        <div>{item.invoicePrice}</div>
                    </Form.Item>
                    <Form.Item label="送货联系人" >
                      <div>{item.sendName}</div>
                    </Form.Item>
                    <Form.Item label="送货电话" >
                      <div>{item.sendPhone}</div>
                    </Form.Item>
                    <Form.Item label="送货地址" >
                      <div>{item.sendAddress}</div>
                    </Form.Item>
                    <Form.Item label="序列号" >
                          <div>{item.deviceSerialNo}</div>
                        </Form.Item>
                  </Col>
                  <Col span={8}>
                      <Form.Item label="订单号">
                      <div>{item.orderSn}</div>
                        </Form.Item>
                    <Form.Item label="货号">
                        <div>{item.factoryCode}</div>
                    </Form.Item>
                    <Form.Item label="未税单价">
                        <div>{item.priceWithoutTax}</div>
                    </Form.Item>
                    <Form.Item label="物流单号">
                        <div>{item.expressNo}</div>
                    </Form.Item>
                    <Form.Item label="开票日期">
                        <div>{formatDate(item.invoiceDate)}</div>
                    </Form.Item>
                    <Form.Item label="取货地址" >
                      <div>{item.pickupAddress}</div>
                    </Form.Item>
                    <Form.Item label="医院名称">
                      <div>{item.hospitalName}</div>
                    </Form.Item>
                    <Form.Item label="发货日期">
                        <div>{formatDate(item.sendDate)}</div>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="产品名称" >
                      <div>{item.goodsName}</div>
                    </Form.Item>
                    <Form.Item label="产品编码" >
                      <div>{item.materialCode}</div>
                    </Form.Item>
                    <Form.Item label="税率" >
                      <div>{(item.taxRate||item.taxRate===0)&&`${item.taxRate}%`}</div>
                    </Form.Item>
                      <Form.Item label="取货日期" >
                      <div>{formatDate(item.pickupDate)}</div>
                    </Form.Item>
                    <Form.Item label="取货联系人" >
                      <div>{item.pickupName}</div>
                    </Form.Item>
                    <Form.Item label="取货电话" >
                      <div>{item.pickupPhone}</div>
                    </Form.Item>
                        <Form.Item label="中心号">
                        <div>{item.centerNo}</div>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>
                    <Form.Item label="用户备注" >
                      <div>{item.userRemark}</div>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="泉心备注" >
                      <div>{item.selfRemark}</div>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>
                    <Form.Item label="证书上传" >
                        <UploadFile
                            fromEntity={"Order"+item.catalog}
                            catalog="Annex"
                            itemInfo = {item}
                            exportType = 'DeviceExportCert'
                            color="#47B2AC"
                            fromEntityId={item.id || ''}
                            isAbleUpload={false}
                          />
                      {/* {item.filePath&&<Button type='link' onClick={()=>{handleWatchCert(item.filePath)}}>查看证书</Button>} */}
                    </Form.Item>
                  </Col>
                </Row>
                </>
                }
              </>
            })}
        </Form>
        }
    </Modal>

  )
})